// Firebase 설정 파일 - 초기화된 인스턴스 export
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDLIBVdOCwCp4kAvxzQS03dJecMjzC1jS4",
  authDomain: "kedu-talk.firebaseapp.com",
  databaseURL: "https://kedu-talk-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kedu-talk",
  storageBucket: "kedu-talk.firebasestorage.app",
  messagingSenderId: "770258293370",
  appId: "1:770258293370:web:c58575d05ee389088721c3",
  measurementId: "G-ELZ3630VCL"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const firestore = getFirestore(app);
const auth = getAuth(app); // Apple/Google 소셜 로그인용 (채팅용 아님)
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, database, firestore, auth, analytics, storage };
export default firebaseConfig;

/* 
설정 방법:

1. Firebase 콘솔 (https://console.firebase.google.com/) 접속
2. 프로젝트 설정 → 내 앱 → 웹 앱 설정 복사
3. 위의 값들을 실제 값으로 교체
4. 저장

주의사항:
- databaseURL은 Realtime Database를 생성해야 얻을 수 있습니다
- Firebase 콘솔 → Realtime Database → 데이터베이스 만들기
*/